<template>
  <div class="hotelBoxWrap" data-guide-key="Hotel Selector">
    <el-popover ref="popover"
                placement="bottom-start" content=""
                title="" width="" trigger="manual"
                popper-class="hotelBoxPopper"
                v-model="popoverVisible">
      <div class="hotelBox" :class="{hotelBox1:!isShow}" slot="reference" ref="reference"  @click="popoverVisible = !popoverVisible">
        <AvatarInitial :name="hotelActiveData.hotelName" size="lg"/>
        <template v-if="isShow">
          <AppTooltip v-if="isNameTruncated" :content="hotelActiveData.hotelName" placement="bottom">
            <div class="name" ref="nameEl">{{hotelActiveData.hotelName}}</div>
          </AppTooltip>
          <div v-else class="name" ref="nameEl">{{hotelActiveData.hotelName}}</div>
        </template>
        <Icon name="unfold-more" class="more"/>
      </div>
      <div class="hotelList">
        <p v-for="(item,index) in hotelList" :class="{active:item.hotelId === currentHotelId}" :key="index" @click="changeHotelData(item)">{{item.hotelName}}</p>
      </div>
    </el-popover>
  </div>
</template>


<script>
import {Icon } from 'tdesign-icons-vue'
import {mapMutations, mapState} from "vuex";
import AvatarInitial from "@/components/common/AvatarInitial.vue";
import AppTooltip from "@/components/common/AppTooltip.vue";
import { isMenuPathEnabled } from "@/utils/featureGates";

export default {
  name:"HotelBox",
  props:{
    isShow:{
      default: false,
    }
  },
  components: {
    Icon,
    AvatarInitial,
    AppTooltip,
  },
  data(){
    return{
      popoverVisible: false,
      hotelActiveData:{hotelName:""},
      // Only wrap the name in a tooltip once it's actually clamped — showing
      // a hover popup that just repeats text already fully visible is noise.
      isNameTruncated: false,
    }
  },
  computed:{...mapState({
      currentHotelId:state => state.hotel.currentHotelId,
      hotelList:state => state.hotel.hotelList,
    })},
  watch:{
    currentHotelId:{
      handler(val){
        if (!Array.isArray(this.hotelList)) return;
        const match = this.hotelList.find(h => h.hotelId === val);
        if (match) this.hotelActiveData = match;
      },
      deep: true,
      immediate: true
    },
    // hotelList loads asynchronously after mount. If currentHotelId didn't change
    // after fetchHotelList completes, the currentHotelId watcher won't re-fire.
    // This watcher ensures hotelActiveData is updated once the list arrives.
    hotelList(newList) {
      if (!Array.isArray(newList)) return;
      const match = newList.find(h => h.hotelId === this.currentHotelId);
      if (match) {
        this.hotelActiveData = match;
      } else if (newList.length) {
        this.hotelActiveData = newList[0];
      }
    },
    hotelActiveData() {
      this.$nextTick(this.checkNameTruncated);
    },
    isShow() {
      this.$nextTick(this.checkNameTruncated);
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.$nextTick(this.checkNameTruncated);
  },
  methods:{
    // -webkit-line-clamp hides overflow without reflowing layout, so
    // scrollHeight (the untruncated content height) exceeding clientHeight
    // (the clamped box's rendered height) reliably means text was cut off.
    checkNameTruncated() {
      const el = this.$refs.nameEl;
      this.isNameTruncated = !!el && el.scrollHeight > el.clientHeight;
    },
    handleClickOutside(event) {
      if (!this.popoverVisible) return
      const triggerBtn = this.$refs.reference
      const popover = this.$refs.popover.$el
      const isClickInside = triggerBtn.contains(event.target) || popover.contains(event.target)
      if (!isClickInside) this.popoverVisible = false
    },
    ...mapMutations("hotel", ["SET_CURRENT_HOTEL"]),
    changeHotelData(data){
      this.SET_CURRENT_HOTEL(data.hotelId);
      // 切酒店不改界面语言，保持用户自己选的语言（原来会强制改回英文，QA：切到 Kimpton 后整个界面变回英文）
      this.popoverVisible = false;
      // 刷新前先回到顶部：否则浏览器会恢复刷新前的滚动位置，新酒店停在上一家看到一半的地方
      window.scrollTo(0, 0);
      const currentPath = this.$route.path;
      if (!isMenuPathEnabled(currentPath, data.menu)) {
        window.location.href = '/index';
      } else {
        window.location.reload();
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style scoped lang="scss">
.hotelBox{
  display: flex;
  justify-content: left;
  align-items: center ;
  gap: 0 9px;
  cursor: pointer;
  min-height: 48px;
  padding: 6px 4px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: transparent;
  transition: background 0.15s ease;
  &:hover {
    background: var(--sidebar-hover);
  }
  .name{
    font-family: InterMedium, sans-serif !important;
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    white-space: wrap;
    color: var(--sidebar-text);
    flex: 1;
    min-width: 0;
    word-break: normal;
    overflow-wrap: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .more{
    flex-shrink: 0;
    font-size: 18px;
    color: var(--sidebar-text-muted);
  }
}
.hotelBox1{
  padding: 6px;
  gap: 0;
  border: none;
  border-radius: 8px;
}
</style>

<style lang="scss">
.hotelBoxPopper{
  padding: 8px;
  min-width: 300px;
  border-radius: 12px !important;
  .popper__arrow{
    display: none!important;
  }
  .hotelList{
    max-height: 350px;
    overflow: auto;
    p{
      margin: 0;
      height: 40px;
      line-height: 40px;
      font-family: Inter, sans-serif !important;
      font-weight: 400;
      font-size: 14px;
      padding: 0 12px;
      cursor: pointer;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p:hover{
      background: #F0F4F8;
      border-radius: 8px;
    }
    .active{
      background: #E6EEF6;
      border-radius: 8px;
      color: #1A365D;
      font-weight: 600;
    }
  }
}
</style>